export default "__VITE_ASSET__DZqqCeu0__"